import Vue from "vue";

import Register from "./Register_Persona.vue";

export function load() {
    const selector = "registration-persona";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(Register, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
